<template>
    <div class="header">
        <header>
            <div class="pc-header">
                <div class="logo"><img src="@/assets/img/logo.png" alt=""></div>
                <nav>
                    <ul class="menu">
                        <li :class="[page.search('/home') >= 0 ? 'active' :  'hvr-underline-from-center', 'menu-item']"
                            @click="$router.push('/')">首页
                        </li>
                        <li :class="[page.search('/about') >= 0? 'active' :  'hvr-underline-from-center', 'menu-item']"
                            @click="$router.push('/about/group')">
                            关于我们
                            <ul class="drop-down">
                                <li @click.stop="jumpPage('/about/group')">公司简介</li>
                                <li @click.stop="jumpPage('/about/culture')">企业文化</li>
                                <li @click.stop="jumpPage('/about/develop')">发展历程</li>
                                <li @click.stop="jumpPage('/about/honor')">资质荣誉</li>
                                <li @click.stop="jumpPage('/about/organization')">组织结构</li>
                                <li @click.stop="jumpPage('/about/environment')">园区环境</li>
                                <li @click.stop="goDetail('/about/duty')">社会责任</li>
                            </ul>
                        </li>
                        <li :class="[page.search('/product') >= 0 ? 'active' :  'hvr-underline-from-center', 'menu-item' ]"
                            @click="$router.push('/product')">
                            产品中心
                            <ul class="drop-down">
                                <li v-for="(item,index) in goodsTitList" :key="index"
                                    @click.stop="jumpGoods(item,index)">{{ item.CategoryName }}
                                </li>
                            </ul>
                        </li>
                        <li :class="[page.search('/news') >= 0 ? 'active' :  'hvr-underline-from-center', 'menu-item']"
                            @click="$router.push('/news')">
                            新闻动态
                            <ul class="drop-down">
                                <li
                                    @click.stop="jumpPage('/news/' + item.path)"
                                    v-for="(item,index) in list"
                                    :key="index"
                                >{{ item.name }}
                                </li>
                            </ul>
                        </li>
                        <li :class="[page.search('/party') >= 0  ? 'active' :  'hvr-underline-from-center', 'menu-item']"
                            @click="$router.push('/party')">党群建设
                        </li>
                        <li :class="[page.search('/support') >=0  ? 'active' :  'hvr-underline-from-center', 'menu-item']"
                            @click="$router.push('/support')">
                            服务支持
                            <ul class="drop-down">
                                <li @click.stop="jumpPage('/support/shop')">专卖店查询</li>
                                <li @click.stop="jumpPage('/support/security')">防伪追溯</li>
                                <li @click.stop="jumpPage('/support/contact')">联系我们</li>
                            </ul>
                        </li>
                        <li :class="[page.search('/join') >=0 ? 'active' :  'hvr-underline-from-center', 'menu-item']"
                            @click="$router.push('/join')">招商加盟
                        </li>
                    </ul>
                </nav>
                <div class="search"><img src="@/assets/img/search.png" alt="" @click="$router.push('/search')"></div>
            </div>

            <div class="md-header">
                <div class="md-logo">
                    <img src="@/assets/img/logo.png" alt="">
                </div>

                <div class="md-menu-icon" @click="showMenu = !showMenu">
                    <img src="@/assets/img/md-menu-close.png" alt="" v-if="showMenu">
                    <img src="@/assets/img/md-menu.png" alt="" v-else>
                </div>

                <div class="md-menu-icon" @click="$router.push('/search')">
                    <img src="@/assets/img/md-search.png" alt="">
                </div>
                <transition name="el-fade-in-linear">
                    <ul class="md-menu" v-show="showMenu">
                        <li
                            :class="[page.search('/home') >= 0 ? 'active-color' : '', 'md-menu-item']"
                            @click="phonePage('/')"
                        >
                            首页
                        </li>

                        <li @click="mineMenu = !mineMenu"
                            :class="[page.search('/about') >= 0 ? 'active-color' : '', 'md-menu-item']"
                        >关于我们
                        </li>
                        <el-collapse-transition>
                            <li class="md-sub-menu" v-show="mineMenu">
                                <div @click.stop="phonePage('/about/group')" class="md-sub-menu-item">公司简介</div>
                                <div @click.stop="phonePage('/about/culture')" class="md-sub-menu-item">企业文化</div>
                                <div @click.stop="phonePage('/about/develop')" class="md-sub-menu-item">发展历程</div>
                                <div @click.stop="phonePage('/about/honor')" class="md-sub-menu-item">资质荣誉</div>
                                <div @click.stop="phonePage('/about/organization')" class="md-sub-menu-item">组织结构</div>
                                <div @click.stop="phonePage('/about/environment')" class="md-sub-menu-item">园区环境</div>
                                <div @click.stop="goDetail('/about/duty')" class="md-sub-menu-item">社会责任</div>
                            </li>
                        </el-collapse-transition>

                        <li :class="[page.search('/product') >= 0 ? 'active-color' : '', 'md-menu-item']"
                            @click="proMenu = !proMenu">产品中心
                        </li>
                        <el-collapse-transition>
                            <li class="md-sub-menu" v-show="proMenu">
                                <div class="md-sub-menu-item" v-for="(item,index) in goodsTitList" :key="index"
                                     @click.stop="jumpGoods(item,index)">{{ item.CategoryName }}
                                </div>
                            </li>
                        </el-collapse-transition>

                        <li
                            :class="[page.search('/news') >= 0 ? 'active-color' : '', 'md-menu-item']"
                            @click="newMenu = !newMenu">新闻动态
                        </li>
                        <el-collapse-transition>
                            <li class="md-sub-menu" v-show="newMenu">
                                <div class="md-sub-menu-item"
                                     @click.stop="phonePage('/news/' + item.path)"
                                     v-for="(item,index) in list"
                                     :key="index"
                                >{{ item.name }}
                                </div>
                            </li>
                        </el-collapse-transition>

                        <li
                            :class="['md-menu-item',page.search('/party') >= 0  ? 'active-color' : '']"
                            @click="phonePage('/party')"
                        >党群建设
                        </li>

                        <li
                            :class="[page.search('/support') >= 0 ? 'active-color' : '', 'md-menu-item']"
                            @click="supportMenu = !supportMenu">服务支持
                        </li>
                        <el-collapse-transition>
                            <li class="md-sub-menu" v-show="supportMenu">
                                <div class="md-sub-menu-item" @click.stop="phonePage('/support/shop')">专卖店查询</div>
                                <div class="md-sub-menu-item" @click.stop="phonePage('/support/security')">防伪追溯</div>
                                <div class="md-sub-menu-item" @click.stop="phonePage('/support/contact')">联系我们</div>
                            </li>
                        </el-collapse-transition>

                        <li
                            :class="[page.search('/join') >= 0 ? 'active-color' : '', 'md-menu-item']"
                            @click="jumpPage('/join')"
                        >招商加盟
                        </li>
                    </ul>
                </transition>
            </div>


        </header>
    </div>
</template>

<script>
import {websiteApi} from "@/api/api";

export default {
    name: 'my-header',
    data() {
        return {
            goodsTitList: [],
            list: [],
            showMenu: false,
            mineMenu: false,
            proMenu: false,
            newMenu: false,
            supportMenu: false
        }
    },
    computed: {
        page() {
            return this.$route.path
        }
    },
    created() {
        this.getTabs()
        this.getGoodCogyList()
    },
    methods: {
        async getTabs() {
            const res = await websiteApi.getArticle({
                Action: 'guanying.articlecategory.list.get',
                ParentCategoryID: 1,
                DeviceType: this.$deviceType
            })

            for (let key in res.Data) {
                if (key == 2) {
                    this.list.push({
                        name: res.Data[key],
                        path: 'information'
                    })
                }

                if (key == 3) {
                    this.list.push({
                        name: res.Data[key],
                        path: 'magazine'
                    })
                }


                if (key == 4) {
                    this.list.push({
                        name: res.Data[key],
                        path: 'notice'
                    })
                }

                if (key == 5) {
                    this.list.push({
                        name: res.Data[key],
                        path: 'video'
                    })
                }

                if(key == 17){
                    this.list.push({
                        name: res.Data[key],
                        path: 'group'
                    })
                }

                if(key == 19){
                    this.list.push({
                        name: res.Data[key],
                        path: 'industry'
                    })
                }
            }


        },
        jumpPage(url) {
            this.$router.push(url)
            this.showMenu = false
        },
        phonePage(url) {
            this.$router.push(url)
            this.showMenu = false
            this.mineMenu = false
            this.proMenu = false
            this.newMenu = false
            this.supportMenu = false
        },
        async getGoodCogyList() {
            const res = await websiteApi.getGoods({
                Action: "guanying.showcategory.list.get",
                DeviceType: this.$deviceType,
            })
            if (res.Status === "Success") {
                this.goodsTitList = res.Data;
            }
        },
        jumpGoods(item, index) {
            this.$router.push({
                path: '/product',
                query: {
                    ShowCategoryID: item.ShowCategoryID,
                    i: index
                }
            })
            this.showMenu = false
        },
        goDetail(page){
            const url = window.location.protocol+"//"+window.location.host
            window.open(url + page)
        }
    }
}
</script>

<style lang="scss" scoped>
@mixin active {
    color: #D60C00;
    //border-bottom: 5px solid #D60C00;
}

.pc-header {
    width: 100%;
    height: 100px;
    align-items: center;
    justify-content: space-between;
}

.logo {
    width: 98px;
    height: 75px;
    margin-left: 23px;

    > img {
        width: 88px;
        height: 75px;
    }
}

nav {
    flex: 1;
    height: 100%;

    > .menu {
        display: flex;
        justify-content: center;
        height: 100%;

        > .menu-item {
            position: relative;
            display: inline-block;
            height: 100%;
            line-height: 100px;
            font-size: 22px;
            text-align: center;
            margin: 0 30px;
            cursor: pointer;

            &:hover {
                color: #D60C00;

                .drop-down {
                    display: block;
                }
            }

            .drop-down {
                position: absolute;
                display: none;
                top: 100px;
                left: -24px;
                width: 140px;
                padding: 20px 0;
                background: #FFFFFF;
                border: 1px solid #EEEEEE;
                box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
                opacity: 0.9;
                font-size: 16px;
                font-family: SimHei;
                font-weight: 400;
                color: #333333;
                line-height: 36px;
                z-index: 9999;

                > li {
                    &:hover {
                        color: #D60C00;
                    }
                }
            }
        }

    }
}

.active {
    color: #D60C00;
    border-bottom: 5px solid #D60C00;
}

.search {
    width: 42px;
    height: 42px;
    margin-right: 47px;
    cursor: pointer;

    > img {
        width: 100%;
        height: 100%;
    }
}


// 移动端

.md-header {
    position: relative;
    display: block;
    height: 64px;
    line-height: 64px;
    padding: 0 16px;

    .md-logo {
        width: 44px;
        height: 37px;
        float: left;

        > img {
            width: 100%;
            height: 100%;
        }
    }

    .md-menu-icon {
        float: right;
        cursor: pointer;
        width: 29px;
        height: 29px;

        > img {
            width: 100%;
            height: auto;
        }

        &:nth-child(2) {
            margin-left: 10px;
        }
    }

    .md-menu {
        position: absolute;
        top: 64px;
        left: 0;
        width: 100%;
        min-height: 100vh;
        z-index: 999999;
        background: #fff;

        .md-menu-item {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 55px;
            background: #FFFFFF;
            border-top: 1px solid #DDDDDD;
            font-size: 17px;
            color: #333333;
            cursor: pointer;

            &:hover {
                color: #DF0615;
            }
        }

        .active-color {
            color: #DF0615;
        }

        // 子菜单
        .md-sub-menu {
            display: flex;
            flex-wrap: wrap;
            width: 100%;
            background: #fff;
            padding: 10px 25px;
            //justify-content: center;
            border-top: 1px solid #ddd;

            .md-sub-menu-item {
                font-size: 15px;
                font-family: SimHei;
                font-weight: 400;
                color: #888888;
                line-height: 35px;
                padding: 0 15px;
                text-align: center;
                cursor: pointer;
                width: 50%;
                &:hover {
                    color: #DF0615;
                }
            }
        }


    }
}


@media screen and (max-width: 960px) {
    .md-header {
        display: block;
    }
    .pc-header {
        display: none;
    }

}

@media screen and (min-width: 960px) {
    .md-header {
        display: none;
    }
    .pc-header {
        display: flex;
    }
}
</style>
